import { render, staticRenderFns } from "./EnvelopeEdit.vue?vue&type=template&id=22083b0e&scoped=true&"
import script from "./EnvelopeEdit.vue?vue&type=script&lang=js&"
export * from "./EnvelopeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22083b0e",
  null
  
)

export default component.exports